// 1. Dependencies
import { nodeConfig } from '@scripts/mixins';

// 2. Configuration
const NAMESPACE = 'header';
const DEFAULT_SELECTOR = '[data-js-header]';
const DEFAULT_SETTINGS = {
};

// 3. Module
class Header {
	/** @param {HTMLElement} node */
	constructor(node, config) {
		this.elNode = node;

		this.config = config;
		this.observer = null;
	}

	_onIntersection([entry]) {
		this.elNode.classList.toggle('state-sticky', entry.intersectionRatio < 1);
	}

	bindUI() {
		this.observer.observe(this.elNode);
	}

	init() {
		this.observer = new IntersectionObserver(
			this._onIntersection.bind(this),
			{threshold: [1]}
		);

		this.bindUI();
	}
}

// 4. Factory Function
export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	const listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		const config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		const module = new Header(node, config);

		module.init();

		return module;
	});
}
